import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { isEmbedded } from "@/lib/api";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Giveaways from "@/pages/Giveaways";
import NewGiveaway from "@/pages/NewGiveaway";
import GiveawayDetail from "@/pages/GiveawayDetail";
import SuccessScore from "@/pages/SuccessScore";
import Integrations from "@/pages/Integrations";
import Billing from "@/pages/Billing";
import PublicGiveaway from "@/pages/PublicGiveaway";
import PublicCalculator from "@/pages/PublicCalculator";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import Widgets from "@/pages/Widgets";
import WidgetSettings from "@/pages/WidgetSettings";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Launched from Shopify Admin (embedded): skip the marketing page and go straight
  // into the app. ProtectedRoute + AuthProvider handle auth / OAuth install.
  if (isEmbedded() && location.pathname === "/") {
    return <Navigate to={`/dashboard${location.search}`} replace />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/g/:id" element={<PublicGiveaway />} />
      <Route path="/calculator" element={<PublicCalculator />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/tos" element={<TermsOfService />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/giveaways" element={<ProtectedRoute><Giveaways /></ProtectedRoute>} />
      <Route path="/giveaways/new" element={<ProtectedRoute><NewGiveaway /></ProtectedRoute>} />
      <Route path="/giveaways/:id" element={<ProtectedRoute><GiveawayDetail /></ProtectedRoute>} />
      <Route path="/success-score" element={<ProtectedRoute><SuccessScore /></ProtectedRoute>} />
      <Route path="/integrations" element={<ProtectedRoute><Integrations /></ProtectedRoute>} />
      <Route path="/widgets" element={<ProtectedRoute><Widgets /></ProtectedRoute>} />
      <Route path="/widgets/:widget" element={<ProtectedRoute><WidgetSettings /></ProtectedRoute>} />
      <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
